import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
var PrimeIcon = function PrimeIcon() {
  return import('@/components/atoms/PrimeIcon');
};
var SubmitButton = function SubmitButton() {
  return import('@/components/atoms/SubmitButton');
};
var AssetImage = function AssetImage() {
  return import('@/components/atoms/AssetImage');
};
var PartySlider = function PartySlider() {
  return import('@/components/molecules/PartySlider');
};
var DropSphere = function DropSphere() {
  return import('@/components/molecules/DropSphere');
};
var QuestEnemy = function QuestEnemy() {
  return import('@/components/molecules/QuestEnemy');
};
import Nl2br from 'vue-nl2br';
var RecoveryStaminaModal = function RecoveryStaminaModal() {
  return import('@/components/organisms/RecoveryStaminaModal');
};
var StaminaIcon = function StaminaIcon() {
  return import('@/components/atoms/StaminaIcon');
};
var BuffCheckModal = function BuffCheckModal() {
  return import('@/components/organisms/adventure/BuffCheckModal');
};
export default {
  components: {
    Modal: Modal,
    PrimeIcon: PrimeIcon,
    SubmitButton: SubmitButton,
    AssetImage: AssetImage,
    PartySlider: PartySlider,
    DropSphere: DropSphere,
    QuestEnemy: QuestEnemy,
    Nl2br: Nl2br,
    RecoveryStaminaModal: RecoveryStaminaModal,
    StaminaIcon: StaminaIcon,
    BuffCheckModal: BuffCheckModal
  },
  props: {
    adventure: {
      type: Object,
      default: function _default() {},
      required: true
    },
    prevSelectedPartryNo: {
      type: Number,
      default: 0
    },
    isNormalQuest: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      selectedTeam: 0,
      challengeCount: 1,
      teamSwiperOption: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 8,
        breakpointsInverse: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 16,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }
          }
        },
        on: {
          init: function init() {
            return _this.teamSwiperInit();
          },
          slideChange: function slideChange() {
            if (window.innerWidth > 768) {
              if (_this.teamSwiper.activeIndex <= _this.selectedTeam && _this.selectedTeam <= _this.teamSwiper.activeIndex + 2) {
                return;
              }
            }
            _this.selectedTeam = _this.teamSwiper.activeIndex;
          }
        }
      },
      isRecoveryStaminaModalShown: false,
      isBuffCheckModalShown: false,
      isMulti: false,
      staminaPerc: 100,
      goToQuestSpinner: false,
      isLoading: true
    };
  },
  computed: {
    myOwnIds: function myOwnIds() {
      return useExtensionStore().myOwnIds;
    },
    getHero: function getHero() {
      return useHeroStore().getHero;
    },
    getExtension: function getExtension() {
      return useExtensionStore().getExtension;
    },
    templates: function templates() {
      return useDeckTemplateStore().getDeckTemplates;
    },
    getReward: function getReward() {
      return useRewardStore().getReward;
    },
    bannedTemplate: function bannedTemplate() {
      return useDeckTemplateStore().getBannedTemplates;
    },
    isSelectedTemplateRarityLimit: function isSelectedTemplateRarityLimit() {
      return useDeckTemplateStore().isSelectedTemplateRarityLimit;
    },
    isSelectedTemplateAttrLimit: function isSelectedTemplateAttrLimit() {
      return useDeckTemplateStore().isSelectedTemplateAttrLimit;
    },
    isSameHeroDisabled: function isSameHeroDisabled() {
      return useDeckTemplateStore().isSameHeroDisabled;
    },
    isPhoneValid: function isPhoneValid() {
      return usePhoneNumberStore().isPhoneValid;
    },
    me: function me() {
      return useUserStore().me;
    },
    selectedAdventureType: function selectedAdventureType() {
      return this.adventure.adventureType;
    },
    adventureTypeMaster: function adventureTypeMaster() {
      return useQuestMaster().getAdventureTypeMaster(this.adventure.adventureType);
    },
    isPrime: function isPrime() {
      return usePrimeStore().isPrime;
    },
    isDepartureModalShown: function isDepartureModalShown() {
      return !!Object.keys(this.adventure).length;
    },
    isPrimeOnlyDisabled: function isPrimeOnlyDisabled() {
      return this.adventure.rules.isPrimeOnly && !this.isPrime;
    },
    isPrimeDisabled: function isPrimeDisabled() {
      return !this.isPrime && this.selectedTeam >= 3 && this.selectedTeam <= 9;
    },
    canNotJoinNeedPhonehash: function canNotJoinNeedPhonehash() {
      return this.adventure.rules.isNeedPhonehash && !this.isPhoneValid;
    },
    isRecoveryStaminaBtnShown: function isRecoveryStaminaBtnShown() {
      return this.selectedAdventureType && this.isPossibleStamina && !this.isPossiblePartyLv && !this.isPrimeOnlyDisabled && !this.isPrimeDisabled;
    },
    cannotGo: function cannotGo() {
      return !this.selectedAdventureType || this.isPossibleStamina || this.isPossiblePartyLv || this.isPrimeOnlyDisabled || this.isPrimeDisabled || this.isBannedDeck || !this.challengeCount || this.canNotJoinNeedPhonehash || this.isLoading;
    },
    isPossibleStamina: function isPossibleStamina() {
      return this.adventure.stamina > useUserStore().getStamina.currentStamina;
    },
    isPossiblePartyLv: function isPossiblePartyLv() {
      return this.partyLv > this.getPartyLv(this.templates[this.selectedTeam]);
    },
    partyLv: function partyLv() {
      return this.adventure.partyLevel;
    },
    getAverageDropCount: function getAverageDropCount() {
      if (this.adventure.rarity == 1) return 1;
      if (this.adventure.rarity == 2) return 20;
      if (this.adventure.rarity == 3) return 30;
      if (this.adventure.rarity == 4) return 40;
      if (this.adventure.rarity == 5) return 50;
      return 0;
    },
    isBannedDeck: function isBannedDeck() {
      return this.bannedTemplate.includes(this.selectedTeam) || this.isSelectedTemplateRarityLimit(this.selectedTeam, this.adventure) || this.isSelectedTemplateAttrLimit(this.selectedTeam, this.adventure) || this.isSameHeroDisabled(this.selectedTeam, this.adventure);
    }
  },
  watch: {
    adventure: {
      handler: function handler() {
        if (!this.isDepartureModalShown) return;
        this.init();
      },
      deep: true
    }
  },
  beforeMount: function beforeMount() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    init: function init() {
      this.selectedTeam = useQuestStore().getCurrentDeckNo;
    },
    fetchMyOwnData: function fetchMyOwnData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return useDeckTemplateStore().fetchDeckTemplates();
            case 2:
              useDeckTemplateStore().setBannedTemplates(_this2.adventure.bannedRarity);
              _this2.isLoading = false;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    teamSwiperInit: function teamSwiperInit() {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.teamSwiper.slideTo(_this3.selectedTeam, 0);
      });
    },
    go: function go() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _this4.goToQuestSpinner = true;
              _this4.$parent.isAfterGo = true;
              _context3.next = 5;
              return useQuestStore().startAdventure({
                adventureType: _this4.selectedAdventureType,
                deckNo: _this4.selectedTeam,
                challengeCount: _this4.challengeCount
              });
            case 5:
              _context3.next = 7;
              return useDeckTemplateStore().fetchTemplateAssets(_this4.templates[_this4.selectedTeam], true);
            case 7:
              _this4.$adService.SendToGTM('quest', _this4.selectedAdventureType);
              _this4.$localStorage.set('prevAdventureType', _this4.adventure);
              _this4.$localStorage.set('prevTemplateNo', _this4.selectedTeam);
              _this4.$emit('after-go', useQuestStore().getAdventureResult.battleIdsList);
              _this4.selectedTeam = 0;
              _context3.next = 22;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](0);
              _this4.goToQuestSpinner = false;
              _this4.$parent.isAfterGo = false;
              _context3.next = 20;
              return usePrimeStore().fetchIsPrime();
            case 20:
              console.error(_context3.t0);
              _this4.$toast.error('Error.');
            case 22:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 14]]);
      }))();
    },
    selectTeamTemplate: function selectTeamTemplate(teamIndex) {
      return this.selectedTeam = teamIndex;
    },
    getPartyLv: function getPartyLv(party) {
      var lv = 0;
      if (party) {
        for (var i = 0; i < party.unitsList.length; i++) {
          var hero = this.getHero(party.unitsList[i].heroId);
          if (party.unitsList[i].asset || party.unitsList[i].heroId < 11000 || party.unitsList[i].heroId >= 12000) {
            lv += this.$constants.PARTY_LV_CALCULATE[hero.rarity];
            lv += Math.floor(hero.lv / 5);
          }
        }
      }
      return lv;
    },
    partyEdit: function partyEdit() {
      this.saveAdventure();
      this.$router.push(this.localePath({
        path: "/parties",
        query: {
          partyIndex: Number(this.selectedTeam),
          quest: true
        }
      }));
    },
    saveAdventure: function saveAdventure() {
      this.$localStorage.set('prevAdventureType', this.adventure);
      this.$localStorage.set('prevTemplateNo', this.selectedTeam);
    },
    recoveryStaminaModalOpen: function recoveryStaminaModalOpen() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return useConsumableStore().fetchLimitedMyItems();
            case 2:
              _this5.isRecoveryStaminaModalShown = true;
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getRewardCnt: function getRewardCnt(stageIndex) {
      var rewardCnt = 0;
      for (var i = 0; i <= stageIndex; i++) {
        rewardCnt += this.adventure.adventureStagesList[i].reward.itemCnt;
      }
      return rewardCnt;
    },
    getOfferDropRate: function getOfferDropRate(stageIndex) {
      var offerDropRate = 0;
      for (var i = 0; i <= stageIndex; i++) {
        offerDropRate += this.adventure.adventureStagesList[i].offerDropRate;
      }
      return offerDropRate / 1000;
    },
    setIsMulti: function setIsMulti() {
      this.isMulti = true;
      this.calcStaminaChallengeCount(0);
    },
    resetIsMulti: function resetIsMulti() {
      this.isMulti = false;
      this.challengeCount = 1;
    },
    calcStaminaChallengeCount: function calcStaminaChallengeCount(amount) {
      if (this.staminaPerc + amount < 10) {
        this.staminaPerc = 10;
      } else if (this.staminaPerc + amount >= 100) {
        this.staminaPerc = 100;
      } else {
        this.staminaPerc += amount;
      }
      var staminaUse = useUserStore().getStamina.currentStamina * this.staminaPerc / 100;
      this.challengeCount = Math.floor(staminaUse / this.adventure.stamina);
    }
  }
};